var getContrastYIQ = function(color) {
  var hex = '#';
  var r, g, b;
  if (color.indexOf(hex) > -1) {
     r = parseInt(color.substr(0, 2), 16);
     g = parseInt(color.substr(2, 2), 16);
     b = parseInt(color.substr(4, 2), 16);
  } else {
     color = color.match(/\d+/g);
     r = color[0];
     g = color[1];
     b = color[2];
  }

  var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? 'black' : 'white';
}

function applyGliderSliderBanner(number){
  const sliders = document.querySelectorAll(".gliderBanner");

  for (let i = 0; i < sliders.length; i++) {
    const slide = sliders[i];
  
    const gliderSlider = new Glider(slide, {
      slidesToShow: 1,
      dots: ".dots",
      duration: 0.25,
      scrollLock : true,
      draggable: true,
      arrows: {
        prev: ".glider-slider-p",
        next: ".glider-slider-n" 
      },
      responsive: [
        { // screens greater than >=300px
          breakpoint: 300,
          settings: { // Set to `auto` and provide item width to adjust to viewport
            slidesToShow: 1,
            scrollLock : true,
            slidesToScroll: "auto",
            duration: 0.25
          }
        }, { // screens greater than >= 1024px
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            scrollLock : true,
            slidesToScroll: 1,
            itemWidth: 150,
            duration: 0.25
          }
        }
      ]
    })

    gliderSlider.scrollTo(number)

  }

}

applyGliderSliderBanner();

document.addEventListener('shopify:section:load', function(event){
  applyGliderSliderBanner(0);

});
document.addEventListener('shopify:block:select', function(event) {
   const blockSelectedIsSlide =event.target.offsetLeft;

  applyGliderSliderBanner(blockSelectedIsSlide);
});
document.addEventListener('shopify:block:deselect', function(event) {
  applyGliderSliderBanner();
});

